// @flow

// useHoverState returns the current hover state in the form of a transition
// state (see useTransitionManager) as well as some mouse over/leave event
// handlers that can be used on a DOM node.

import { useState, useCallback } from 'react';
import useTransitionManager, {
  DEFAULT_TRANSITION_DURATION_MS,
  type TransitionState,
} from 'app/common/react/components/PinRep/Hooks/useTransitionManager';

type ReturnValues = {|
  isHovering: boolean,
  hoverTransitionState: TransitionState,
  handleMouseOver: () => void,
  handleMouseLeave: () => void,
|};

// TODO (rjames): tests for this function
export default function useHoverState(): ReturnValues {
  const [isHovering, setHovering] = useState(false);

  const hoverTransitionState = useTransitionManager(isHovering, 0, DEFAULT_TRANSITION_DURATION_MS);

  const handleMouseOver = useCallback(() => setHovering(true), [setHovering]);
  const handleMouseLeave = useCallback(() => setHovering(false), [setHovering]);

  return {
    isHovering,
    hoverTransitionState,
    handleMouseOver,
    handleMouseLeave,
  };
}
